import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import moment from 'moment';

const AboutChannel = ({
  channel: { name, createdAt, ...channel },
  ...props
}) => {
  return (
    <div className='flex-columns'>
      <Typography type='headline'>About {name}</Typography>
      <Typography type='bold'>Purpose:</Typography>
      { channel.topic && <Typography>{channel.topic}</Typography> }
      <Typography type='bold'>Created:</Typography>
      <Typography>{moment(createdAt).format('MMMM D, YYYY')}</Typography>
    </div>
  );
};

AboutChannel.propTypes = {
  channel: PropTypes.object
};

export default AboutChannel;
